module.exports = __webpack_public_path__ + "img/Frame_22.cf6443ad.png";